import React, { useEffect, useState } from "react";
import Button from "../../Components/Button";

interface IParentEnquiryProps {
    isLoggedIn: boolean
    enquiryType: string
    centreName: string
    [key: string]: any
}

function Finish(props: IParentEnquiryProps) {
    const { enquiryDetail, centreName } = props;
    const [emailValid, setEmailValid] = useState(true);
    const [parentType, setParentType] = useState()

    let formData = new FormData();
    formData.append('email', enquiryDetail.parentDetail.email);

    useEffect(() => {
        fetch(`/parentaccount/validateemail/exist`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                // Email not registration
                if (!data) {
                    setEmailValid(false)
                    props.setIsEmailValid(false)
                }
                else {
                    props.setIsEmailValid(true)
                    handleCheckTypeAccount()
                }
            })
            .catch(error => {
                console.error(error);
            })
    }, [])

    const handleCheckTypeAccount = () => {
        fetch(`/parentaccount/verifytype`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                setParentType(data.userType)
            })
            .catch(error => {
                console.error(error);
            })
    }

    const handleClick = () => {
        props.onNext({
            data: null
        });
    }

    const handleGoToEnquiries = () => {
        document.getElementById('enquiries-button').click();
        props.onClose();
    }

    return (
        <>
            <div className="text-[#3A3A3A] font-poppins z-[1005] inset-0">
                <h1 className="text-[24px] text-[#3A3A3A] font-semibold mb-6">
                    {props.enquiryType === "4" ? "Your request is on its way" : "Your enquiry is on its way"}
                    <img src="/img/enquiry/acknowledgement.png" width="32px" height="32px" className="inline-block ml-6" />
                </h1>
                <p className="text-[16px] font-normal">We’ve passed your message on to {centreName}, and a confirmation email is zipping its way to your inbox.</p>

                {emailValid ? (
                    props.isLoggedIn ? (
                        <>
                            <p className="mt-[20px] text-[16px] font-normal">
                                You can easily track and manage your enquiries in your Enquiries Page.
                            </p>
                            <Button
                                onClick={handleGoToEnquiries}
                                customClass="cta-open-enquiry-modal w-full md:w-fit mx-auto mt-6"
                                variant="primary"
                                fullWidth
                            >
                                Go To Enquiries
                            </Button>
                        </>
                    ) : parentType === 2 ? (
                        <>
                            <div className="bg-[#D9D8DF] w-full !my-[24px] h-[1px]"></div>
                            <p className="text-[18px] font-medium">
                                Sign in and save your details to manage enquiries
                            </p>
                            <Button
                                onClick={handleClick}
                                customClass="cta-sign-in w-full md:w-fit mx-auto mt-6"
                                variant="primary"
                                fullWidth
                            >
                                Sign In
                            </Button>
                        </>
                    ) : null
                ) : !props.isLoggedIn ?
                    <>
                        <div className="bg-[#D9D8DF] w-full !my-[24px] h-[1px]"></div>
                        <p className="text-[18px] font-medium">
                            {props.enquiryType === "4" ? "Save your details to manage bookings and enquiries" : "Save your details to manage enquiries"}
                        </p>
                        <Button
                            onClick={handleClick}
                            customClass="cta-create-account w-full md:w-fit mx-auto mt-6 cta-register"
                            variant="primary"
                            fullWidth
                        >
                            Create Account
                        </Button>
                    </> : <>
                        <p className="mt-[20px] text-[16px] font-normal">
                            You can easily track and manage your enquiries in your Enquiries Page.
                        </p>
                        <Button
                            onClick={handleGoToEnquiries}
                            customClass="w-full md:w-fit mx-auto mt-6 cta-open-modal-enquiry"
                            variant="primary"
                            fullWidth
                        >
                            Go To Enquiries
                        </Button>
                    </>
                }

                {/*{parentType == 2 ? !props.isLoggedIn ?*/}
                {/*    <>*/}
                {/*        <div className="bg-[#D9D8DF] w-full !my-[24px] h-[1px]"></div>*/}
                {/*        <p className="text-[18px] font-medium">{emailValid ? "Sign in and save your details to manage  enquiries" : "Save your details to manage enquiries"}</p>*/}
                {/*        <Button onClick={handleClick} customClass="w-full md:w-fit mx-auto mt-6" variant='primary' fullWidth>{emailValid ? "Sign In" : "Create Account"}</Button>*/}
                {/*    </> :*/}
                {/*    <>*/}
                {/*        <p className="mt-[20px] text-[16px] font-normal">You can easily track and manage your enquiries in your Enquiries Page.</p>*/}
                {/*        <Button onClick={handleGoToEnquiries} customClass="w-full md:w-fit mx-auto mt-6" variant='primary' fullWidth>Go To Enquiries</Button>*/}
                {/*    </>*/}
                {/*    : <></>*/}
                {/*}*/}
            </div>
        </>
    )


}

export default Finish;
